var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card -shadow"},[_c('h3',{staticClass:"title"},[_vm._v("Archived Stock Movements")]),_c('archived-stock-movement-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }